/**
 * @export
 * @class Latest
 */
import { get, getAll } from '../../helpers/utilities';

import { PostsViewer } from './posts-viewer';
import { RenderPost } from './render_post';
import { SinglePost } from './single-post';

export class Latest {
    public static id = 'latest';

    
    /**
     * Creates an instance of Latest.
     */
    constructor() {
        this.displayPagePost();
        this.renderSinglePost();
        
        new PostsViewer();
    }

    /**
     * Initiates a basic lightbox for the current page post
     * 
     * @private
     * @returns void
     */
    private displayPagePost(): void {
        const template = get('#js-latest__single-post') as HTMLTemplateElement;
        if(template) new SinglePost(template);
    }


    /**
     * Opens the news item on click
     * 
     * @private
     * @returns void
     */
    private renderSinglePost(): void {
        const links = getAll('.js-latest__news-item-link') as HTMLAnchorElement[];
        if(links) {
            window.addEventListener('click', (event) => {
                const eventTarget = (event.target) as HTMLAnchorElement;
                const target      = eventTarget.classList.contains('js-latest__news-item-link') ? eventTarget : eventTarget.closest('.js-latest__news-item-link') as HTMLAnchorElement;
                if(target) {
                    const url = target.href;
                    if(url) new RenderPost(url);
                    event.preventDefault();
                }
            });
        }
    }
}
